var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/phone_number/index.js
 ** module id = 942
 ** module chunks = 0
 **/